import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import NotifyMessage from "./Component/Others/NotifyMessage";

// const SECRET_KEY = "mySecretKey";
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return null;
  }
};

const UserAutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "userid" || event.key === "userRoll") {
        const storedUserID = decryptData(localStorage.getItem("userid"));
        const storedUserRoll = decryptData(localStorage.getItem("userRoll"));

        if (!storedUserID || !storedUserRoll) {
          NotifyMessage("Session expired! Logging out...", "danger");
          localStorage.clear();
          navigate("/login");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  return null;
};

export default UserAutoLogout;
